import { render } from "./schedule-thursday.vue?vue&type=template&id=f3dd98c4"
import script from "./schedule-thursday.vue?vue&type=script&lang=js"
export * from "./schedule-thursday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__